/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState, useRef, useEffect, React } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { BellIcon, MenuIcon, XIcon } from '@heroicons/react/outline'
import SimplifiedHeader from '../../components/SimplifiedHeader'
import Cta from '../../components/Cta'
import GiveawayForm from './GiveawayForm'
import NotificationBar from '../../components/NotificationBar'
import LoadingBar from 'react-top-loading-bar';
import useTitle from '../../hooks/useTitle'
import { useUser } from '../../providers/UserProvider'
import { useTheme } from '../../providers/ThemeProvider'
import {
  useHistory,
  useLocation
} from "react-router-dom";

import AuthService from '../../services/AuthService'
import AffiliateService from '../../services/AffiliateService'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const queryString = require('query-string');

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const ConfirmationView = () => {
  return (
    <>
      <SimplifiedHeader showLogin="true" />
      <div className="container mx-auto bg-white">
        <div className="bg-white">
          <div className="md:max-w-login-container mx-auto text-center py-12">
            <div className="flex flex-wrap">
                <h2 className="flex-grow font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                  <span className="font-header text-login-hero-mobile md:text-login-hero block">One last thing…</span>
                </h2>
            </div>
  
            <div className="mt-5 md:mt-10 font-subtitle flex-none max-w-2xl mx-auto">
              <span className="text-grey-dark text-subtitle-mobile md:text-subtitle">Check your email for the link to verify your account. </span>
            </div>
          </div>
      </div>
    </div>
    </>
  )
}


function GiveawayView(props) {
  const AUTH_URL = AuthService.AUTH_URL;
  const REDIRECT_URL = AuthService.REDIRECT_URL;
  const COGNITO_CLIENT_ID = AuthService.COGNITO_CLIENT_ID;

  const loadingBarRef = useRef(null);

  const [openForm, setOpenForm] = useState(true);
  const [ theme, themeDispatch ] = useTheme();

  return (
    <>
      <LoadingBar color='#0173FF' ref={loadingBarRef} />
    <div className="container">
      <SimplifiedHeader showLogin="true" />
    </div>
      <NotificationBar />
      <div className="mx-auto bg-white" style={{height:"88vh"}}>
        <div className="bg-white h-full">
          <div className="max-w-[1440px] h-full xl:grid xl:grid-cols-2 mx-auto ">

    {/* <div className="hidden xl:block bg-sheers bg-contain bg-no-repeat"> */}
            <div className="hidden xl:block bg-sheers bg-center bg-contain bg-no-repeat">
              <div className="w-full h-full  flex">
                <div className="mt-auto px-12 pb-12">
                  <h2 className="hidden font-secondary text-white text-headline-1-lg">Mizutani Shears</h2>
                  <p className="hidden font-primary text-white text-body-1 mt-5 ">
                    One grand prize winner was selected to receive a free pair of handcrafted Stephen Moody Model Mizutani scissors, which retail for $850 or more, and every entrant unlocked the chance to get a pair at $698, more than $150 off.
                </p>
                  <p className="font-primary text-white text-body-1 mt-5 "></p>
                </div>
              </div>
            </div>

            <div className="form py-12 px-8 text-center">
              <div className="flex flex-wrap">
                <h2 className="flex-grow font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                  <span className="font-header text-login-hero-mobile md:text-login-hero block">
                    Enter To Win A Free Pair of Mizutani Shears!
                  </span>
                </h2>
              </div>

              <div className="text-center w-full xl:hidden">
                <img className="object-cover w-56 md:w-96 mx-auto" src="/images/sheers_side.png" />
              </div>
  
              <div className="mt-5 md:mt-10 font-subtitle flex-none max-w-2xl mx-auto">
                <p className="text-grey-dark text-subtitle-mobile md:text-subtitle">One grand prize winner was selected to receive a free pair of handcrafted Stephen Moody Model Mizutani scissors, which retail for $850 or more, and every entrant unlocked the chance to get a pair at $698, more than $150 off.</p>
    <br />
                <p className="text-grey-dark text-subtitle-mobile md:text-subtitle"><strong>This giveaway has ended,</strong> but you can still register below to access hundreds of dollars in savings on barbering and hair styling supplies, tools, implements, equipment and more.</p>
              </div>
      
              <div className="mt-5 md:mt-10">
                <small className="font-subtitle text-grey-light text-terms-subtitle-mobile md:text-terms-subtitle">By signing up, I agree to the <a className="border-b-2" href="/terms-of-service">Terms of Use</a> and <a className="border-b-2" href="/privacy-policy">Privacy Policy</a></small>
              </div>
    
              <div className="hidden mt-5 md:mt-10 flex justify-center">
                <a 
                  className="inline-flex items-center justify-center px-14 py-4 border border-blue-700 font-cta-label text-subtitle-mobile md:text-subtitle rounded-full text-black bg-white hover:text-white hover:bg-blue-700"
                  href={`${AUTH_URL}/oauth2/authorize?identity_provider=Google&redirect_uri=${REDIRECT_URL}&response_type=CODE&client_id=${COGNITO_CLIENT_ID}&scope=aws.cognito.signin.user.admin email openid profile`}
                ><FontAwesomeIcon icon={['fab', 'google']} /><span className="ml-4">Sign up with Google</span></a>
              </div>
    
              <div className="hidden mt-5 md:mt-10 md:w-120 font-content relative mx-auto">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-300" />
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="px-2 bg-white text-grey-light text-terms-subtitle-mobile md:text-terms-subtitle">Or sign up with email</span>
                </div>
              </div>
    
              <GiveawayForm token={props.token} setConfirmed={props.setConfirmed} loadingBarRef={loadingBarRef} />
              <div className="mt-5 md:mt-10">
                <small className="font-subtitle text-grey-light text-terms-subtitle-mobile md:text-terms-subtitle"><a className="border-b-2" target="_blank" href="https://mizutaniscissors.com/shop/series/acro/stephen-moody/">Learn more about the prize here.</a></small>
              </div>
  
              <div className="mt-5 md:mt-10">
                <small className="font-subtitle text-grey-light text-[12px]">Open to U.S. Residents ages 18 and older. No purchase necessary. Entries accepted until Friday April 15, 2022 at 11:59 p.m. ET.  Discounted price will be available for a limited time or until inventory runs out, whichever comes first. Prizes provided by Chamber Convoy, Inc. This giveaway is not affiliated with or endorsed by Mizutani Scissors.</small>
              </div>

            </div>
            </div>

      </div>
    </div>
    </>
  )
}

const GiveawayApp = (props) => {
  let token = null;
  let affiliateId = null;
  let branding = null;
  let params = queryString.parse(useLocation().search);

  const [ confirmed, setConfirmed ] = useState(false);
  const [user, userDispatch] = useUser();
  const [ theme, themeDispatch ] = useTheme();

  if (params._ref) {
    token = params._ref;
  }

  if (params._a) {
    affiliateId = params._a;
  }

  useEffect(() => {
    console.log(theme);
    //branding = AffiliateService.getAffiliateBranding("GIVEAWAY1");
    //console.log(branding);
    //themeDispatch({ type: 'theme/set', payload: branding });
  }, []);


  useTitle("Welcome | The Convoy | Save on everyday business expenses.");

  return (
    <div>
      {
        ((!confirmed)? <GiveawayView token={token} setConfirmed={setConfirmed} /> : <ConfirmationView /> )
      }
    </div>
  )
}


export default GiveawayApp;

